import { useTranslation } from 'react-i18next';
import { categoryNames, itemNames, type PromotionRule } from '@/utils/promotions';

const DEFAULT_MAX_CHIPS = 8;

export default function PromotionScopeSummary({
  rule,
  maxChips = DEFAULT_MAX_CHIPS,
}: {
  rule: PromotionRule;
  maxChips?: number;
}) {
  const { t } = useTranslation();

  if (rule.rule_type === 'Cart Threshold') {
    return (
      <p className="text-sm text-gray-600">
        <span className="font-medium text-gray-700">{t('promotions.scope.appliesTo')}: </span>
        {t('promotions.scope.appliesToBill')}
      </p>
    );
  }

  if (rule.apply_scope === 'All' || !rule.apply_scope) {
    return (
      <p className="text-sm text-gray-600">
        <span className="font-medium text-gray-700">{t('promotions.scope.appliesTo')}: </span>
        {t('promotions.scope.appliesToAll')}
      </p>
    );
  }

  const names = rule.apply_scope === 'Categories' ? categoryNames(rule) : itemNames(rule);
  if (!names.length) {
    return (
      <p className="text-sm text-gray-600">
        <span className="font-medium text-gray-700">{t('promotions.scope.appliesTo')}: </span>
        {t(`promotions.scope.${rule.apply_scope.toLowerCase()}`)}
      </p>
    );
  }

  const shown = maxChips > 0 ? names.slice(0, maxChips) : names;
  const extra = names.length - shown.length;

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 mb-1.5">{t('promotions.scope.appliesTo')}</p>
      <div className="flex flex-wrap gap-1.5">
        {shown.map((name, idx) => (
          <span
            key={`${name}-${idx}`}
            className="inline-flex max-w-full px-2.5 py-1 rounded-full bg-gray-100 text-sm text-gray-800"
          >
            <span className="truncate">{name}</span>
          </span>
        ))}
        {extra > 0 && (
          <span className="inline-flex px-2.5 py-1 rounded-full bg-gray-50 text-sm text-gray-500">
            {t('promotions.scope.moreCount', { count: extra })}
          </span>
        )}
      </div>
    </div>
  );
}
